import { render, staticRenderFns } from "./SupplierManagement.vue?vue&type=template&id=3c25425e&scoped=true&"
import script from "./SupplierManagement.vue?vue&type=script&lang=js&"
export * from "./SupplierManagement.vue?vue&type=script&lang=js&"
import style0 from "./SupplierManagement.vue?vue&type=style&index=0&id=3c25425e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25425e",
  null
  
)

export default component.exports